/* ==========================================================================
   Customer reviews (sections/os-reviews.liquid): Loox or hand-picked
   reviews as our own cards. Ported from the Petrol Vibes customer-reviews
   script.

   Loox mode reads Loox's public review feed (what its "snippets" widget
   loads):
     https://loox.io/widget/<id>/snippets/reviews?limit=10&reviewsType=…
   → { reviews: [{ id, rating, text, name, image?, altText? }] }
   It caps at 10 and has no paging. It's undocumented, so every failure
   path (network error, unexpected shape, no reviews) hides the section
   instead of leaving placeholder cards up. Review text is inserted as
   text, never HTML.

   Cards rise in one after another the first time the section scrolls into
   view (unless turned off in the section, or the visitor asks for reduced
   motion).
   ========================================================================== */
(function () {
  var CACHE_PREFIX = 'oshLooxReviews:';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function photoUrl(src) {
    if (!src) return '';
    // The feed hands out tiny thumbnails; Loox serves a ~600px "_mid" of
    // every photo at the same path.
    var url = src.replace(/_cf_tiny(\.\w+)$/, '_mid$1');
    return url.indexOf('//') === 0 ? 'https:' + url : url;
  }

  // "Customer photo review of Your Custom Boat Hanging Silhouette" → the
  // product title, shortened by "Remove from product names".
  function productName(alt, trim) {
    if (!alt) return '';
    var name = alt.replace(/^Customer (photo|video) review of\s+/i, '');
    (trim || '').split(',').forEach(function (phrase) {
      phrase = phrase.trim();
      if (phrase) name = name.split(phrase).join('');
    });
    return name.replace(/\s+/g, ' ').trim();
  }

  // Video reviews are left out: the feed only carries a thumbnail with a
  // play icon baked in, and the video itself can't be played here.
  function isVideoReview(r) { return /\bvideo review\b/i.test(r.altText || ''); }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text) n.textContent = text;
    return n;
  }

  function stars(rating) {
    var wrap = el('span', 'osh-rv__stars');
    wrap.setAttribute('role', 'img');
    wrap.setAttribute('aria-label', 'Rated ' + rating + ' out of 5');
    for (var i = 1; i <= 5; i++) {
      var s = el('span', i > Math.round(rating) ? 'is-off' : '', '★');
      wrap.appendChild(s);
    }
    return wrap;
  }

  // Once a photo loads, its frame takes the photo's own shape, kept between
  // 3:4 and 4:3, so most customer photos show uncropped.
  function fitPhoto(photo, img, done) {
    var apply = function () {
      if (!img.naturalWidth || !img.naturalHeight) return;
      var ratio = Math.max(0.75, Math.min(4 / 3, img.naturalWidth / img.naturalHeight));
      photo.style.aspectRatio = String(ratio);
      if (done) done();
    };
    if (img.complete) apply();
    else img.addEventListener('load', apply);
  }

  function init(root) {
    if (root.dataset.oshReady) return;
    root.dataset.oshReady = '1';

    var d = root.dataset;
    var manual = d.mode === 'manual';
    var track = root.querySelector('[data-osh-rv-track]');
    var prev = root.querySelector('[data-osh-rv-prev]');
    var next = root.querySelector('[data-osh-rv-next]');
    var limit = Math.max(1, Math.min(10, parseInt(d.limit, 10) || 10));
    var isStore = d.source === 'store';
    var photosOnly = d.photosOnly === 'true' && !isStore;
    var inEditor = d.designMode === 'true';
    if (!track) return;

    var fail = function (why) {
      if (inEditor) {
        track.innerHTML = '';
        track.appendChild(el('p', 'osh-rv__empty', manual
          ? 'No hand-picked reviews yet. Add Review blocks to this section, or switch "Reviews from" back to Loox.'
          : 'No Loox reviews to show (' + why + '). Check the Loox widget ID in this section\'s settings.'));
        if (prev) prev.hidden = true;
        if (next) next.hidden = true;
        return;
      }
      root.hidden = true;
    };

    /* ---------------- Arrows ---------------- */
    var updateArrows = function () {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    };
    var step = function (dir) {
      var card = track.querySelector('.osh-rv__card');
      track.scrollBy({ left: dir * (card ? card.getBoundingClientRect().width + 18 : track.clientWidth), behavior: reduceMotion ? 'auto' : 'smooth' });
    };
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);

    // "Read more": one listener for every card.
    track.addEventListener('click', function (e) {
      var more = e.target.closest('.osh-rv__more');
      if (!more) return;
      var card = more.closest('.osh-rv__card');
      var open = card.classList.toggle('is-open');
      more.textContent = open ? (d.lessLabel || 'Show less') : (d.moreLabel || 'Read more');
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    /* ---------------- Entrance animation ---------------- */
    var animate = d.animate === 'true' && !reduceMotion && !inEditor && 'IntersectionObserver' in window;
    var reveal = function () {
      var cards = track.querySelectorAll('.osh-rv__card');
      cards.forEach(function (c, i) { c.style.setProperty('--i', Math.min(i, 6)); });
      if (!animate) return;
      root.classList.add('is-anim');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          root.classList.add('is-in');
          io.disconnect();
        });
      }, { threshold: 0.2 });
      io.observe(track);
    };

    // Only offer "Read more" where the clamp actually cut text off.
    var finish = function () {
      track.removeAttribute('aria-busy');
      reveal();
      requestAnimationFrame(function () {
        track.querySelectorAll('.osh-rv__card').forEach(function (card) {
          var t = card.querySelector('.osh-rv__text');
          var m = card.querySelector('.osh-rv__more');
          if (t && m) m.hidden = !(t.scrollHeight > t.clientHeight + 2);
        });
        updateArrows();
      });
    };

    /* ---------------- Hand-picked reviews ---------------- */
    if (manual) {
      if (!track.querySelector('.osh-rv__card')) { fail('none added'); return; }
      track.querySelectorAll('.osh-rv__photo').forEach(function (photo) {
        var img = photo.querySelector('img');
        if (img) fitPhoto(photo, img, updateArrows);
      });
      finish();
      return;
    }

    if (!d.looxId || !window.fetch) { fail('missing Loox ID'); return; }

    var url = 'https://loox.io/widget/' + encodeURIComponent(d.looxId) + '/snippets/reviews' +
      '?limit=10&reviewsType=' + (isStore ? 'store-reviews' : 'product-reviews');

    /* ---------------- Loox cards ---------------- */
    var render = function (reviews) {
      var list = (reviews || []).filter(function (r) {
        return r && r.text && !isVideoReview(r) && (!photosOnly || r.image);
      }).slice(0, limit);
      if (!list.length) { fail('the feed returned none'); return; }

      track.innerHTML = '';
      list.forEach(function (r) {
        var card = el('article', 'osh-rv__card' + (r.image ? '' : ' osh-rv__card--text'));

        if (r.image) {
          var photo = el('div', 'osh-rv__photo');
          var img = document.createElement('img');
          img.src = photoUrl(r.image);
          img.alt = r.altText || '';
          img.loading = 'lazy';
          img.decoding = 'async';
          photo.appendChild(img);
          card.appendChild(photo);
          fitPhoto(photo, img, updateArrows);
        }

        var body = el('div', 'osh-rv__body');
        body.appendChild(stars(Number(r.rating) || 5));
        body.appendChild(el('p', 'osh-rv__text', r.text.trim()));
        var more = el('button', 'osh-rv__more', d.moreLabel || 'Read more');
        more.type = 'button';
        more.hidden = true;
        body.appendChild(more);

        var foot = el('div', 'osh-rv__foot');
        foot.appendChild(el('span', 'osh-rv__name', r.name || ''));
        if (d.verifiedLabel) {
          var v = el('span', 'osh-rv__verified');
          v.insertAdjacentHTML('beforeend', '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>');
          v.appendChild(document.createTextNode(d.verifiedLabel));
          foot.appendChild(v);
        }
        body.appendChild(foot);

        var prod = productName(r.altText, d.titleTrim);
        if (prod) body.appendChild(el('span', 'osh-rv__product', prod));

        card.appendChild(body);
        track.appendChild(card);
      });
      finish();
    };

    /* ---------------- Fetch (cached per tab session) ---------------- */
    var cached = null;
    try { cached = JSON.parse(sessionStorage.getItem(CACHE_PREFIX + url)); } catch (e) {}
    if (cached) { render(cached); return; }

    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (res) { if (!res.ok) throw res.status; return res.json(); })
      .then(function (data) {
        var reviews = data && Array.isArray(data.reviews) ? data.reviews : null;
        if (!reviews) throw 'unexpected response';
        try { sessionStorage.setItem(CACHE_PREFIX + url, JSON.stringify(reviews)); } catch (e) {}
        render(reviews);
      })
      .catch(function (err) { fail(typeof err === 'string' ? err : 'could not reach Loox'); });
  }

  function initAll() { document.querySelectorAll('[data-osh-reviews]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  // The theme editor swaps in fresh section HTML when a setting changes.
  document.addEventListener('shopify:section:load', initAll);
})();
